export default __webpack_public_path__ + "static/media/TT Norms Pro Bold.b3d2a161.otf";